<template>
  <ComboPicker
    :label="label"
    :orientation="orientation"
    strings="estoque;o"
    icon="mdi-store"
    :value="value"
    @input="(v) => $emit('input', v)"
    :whenEmpty="cWhenEmpty"
    :types="single ? 'single-item' : 'grouped-items'"
    :items="allItems"
  />
</template>

<script>
import ComboPicker from 'oderon-vue/cpts/pickers/ComboPicker'
import { Depot } from '@/models'
import { orderBy } from 'oderon-commons/src/utils'

export default {
  components: {
    ComboPicker
  },
  props: {
    label: { type: String, default: 'Estoque' },
    orientation: { type: String, default: 'horizontal' },
    value: {},
    single: { type: Boolean, default: false },
    whenEmpty: { type: String }
  },
  mounted() {
    this.fetchData()
  },
  data() {
    return {
      allItems: []
    }
  },
  computed: {
    cWhenEmpty() {
      if (this.whenEmpty != null) return this.whenEmpty
      return this.orientation == 'horizontal' ? 'Todos os estoques' : '(Todos)'
    }
  },
  methods: {
    async fetchData() {
      let rows = await Depot.findAll()
      rows = rows.map((r) => ({ id: r.id, name: r.name }))
      this.allItems = orderBy(rows, [['name', 'asc']])
    }
  }
}
</script>

<style></style>
